/* @flow strict */

import * as React from 'react';
import { CTooltipText } from '/client/src/components/tooltip/';

type PropsType = {
  tableTab?: string,
  handleOpenModal: () => void,
  handleSearch: (string) => void,
  isNoSelectedItems?: boolean
};

const EventPageDetailResendSearchbar = ({
  tableTab,
  handleOpenModal,
  handleSearch,
  isNoSelectedItems
}: PropsType): React.Element<'div'> => {
  const [searchString, setSearchString] = React.useState('');

  const handleSearchInput = (e: any) => {
    const val = e.target.value;

    setSearchString(val);
    debouncedChangeHandler(val);
};

const handleSubmitSearch = (val: any) => {
  handleSearch(val);
};

const debouncedChangeHandler = React.useMemo(
  () => _.debounce(handleSubmitSearch, 700)
, []);

  return (
    <div className="container-fluid search-bar">
      <div className="s-table">
        <div className="s-cell">
          <div className="navbar-form" style={{ float:'none', padding:0 }} role="search">
            <div className="input-group event-search green" style={{ width:'100%' }}>
              <input
                className="form-control"
                type="text"
                placeholder="search"
                autoComplete="off"
                onChange={(e: SyntheticInputEvent<HTMLInputElement>): any => {
                  e.persist();
                  handleSearchInput(e);
                }}
              />
              <span className="input-group-btn" style={{ width:'30px' }}>
                <button className="btn btn-default btn-search" type="button" disabled>
                  <span className="icon icon-search" />
                </button>
              </span>
            </div>
          </div>
        </div>

        <div className="s-cell s-cell-buttons" style={{ width: '1%' }}>
          <ul className="nav">
            <li style={{ marginRight: '1rem' }} />

            <li>
              <a href='#'
                target="_blank"
                onClick={(e: any) => {
                  e.preventDefault();
                  handleOpenModal();
                }}
                style={{ opacity: isNoSelectedItems ? '.7' : '1', pointerEvents: isNoSelectedItems ? 'none' : 'auto' }}
              >
                <i className="icon icon-send" style={{ marginRight: '1rem' }} />
                <span>
                  {!tableTab || tableTab === '' || tableTab === 'tickets' ?
                    'Send Ticket' :
                    null
                  }

                  {tableTab === 'receipts' ?
                    'Send Receipts' :
                    null
                  }
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EventPageDetailResendSearchbar;
